module.exports = __webpack_public_path__ + "static/media/info_circle.84a9639d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/info_circle.svg
// module id = 326
// module chunks = 21